var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal5List({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-External_1_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External_1_List",
    "data-name": "External 1_List",
    clipPath: "url(#clip-External_1_List)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_665",
    "data-name": "Ellipse 665",
    transform: "translate(1 1)",
    fill: "#f36d54",
    stroke: "#f36d53",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20390",
    "data-name": "Group 20390",
    transform: "translate(6.639 3.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20366",
    "data-name": "Group 20366",
    transform: "translate(-1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32752",
    "data-name": "Path 32752",
    d: "M86.631,2.321a3.465,3.465,0,0,1-.11.46,2.091,2.091,0,0,1-.493.785q-.58.588-1.167,1.168A.425.425,0,0,1,84.2,4.2a1.038,1.038,0,0,1,.1-.107c.373-.374.748-.745,1.118-1.12a1.241,1.241,0,0,0-1.712-1.8c-.4.385-.792.786-1.186,1.181a.449.449,0,0,1-.436.147.422.422,0,0,1-.247-.661.815.815,0,0,1,.085-.1c.362-.363.726-.724,1.086-1.088A2.131,2.131,0,0,1,84.295.008.165.165,0,0,0,84.323,0h.437c.071.013.143.023.214.04A2.074,2.074,0,0,1,86.523,1.4a2.906,2.906,0,0,1,.108.452Z",
    transform: "translate(-78.907 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32753",
    "data-name": "Path 32753",
    d: "M0,84.443a2.035,2.035,0,0,1,.609-1.485c.382-.389.77-.773,1.157-1.157a.425.425,0,0,1,.665.529,1.028,1.028,0,0,1-.1.113c-.371.372-.744.741-1.114,1.115a1.241,1.241,0,0,0,1.705,1.8c.4-.385.792-.786,1.186-1.181a.453.453,0,0,1,.435-.15.422.422,0,0,1,.251.66.736.736,0,0,1-.079.091q-.559.56-1.12,1.12a2.065,2.065,0,0,1-1.665.631A2.03,2.03,0,0,1,.54,85.85,2.075,2.075,0,0,1,0,84.646a1.867,1.867,0,0,1,0-.2",
    transform: "translate(0 -78.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32754",
    "data-name": "Path 32754",
    d: "M68.021,65.178a.433.433,0,0,1-.149.273q-.475.473-.949.949-.682.682-1.365,1.364a.425.425,0,0,1-.67-.521.678.678,0,0,1,.074-.085L67.27,64.85a.426.426,0,0,1,.6-.054.443.443,0,0,1,.155.382",
    transform: "translate(-62.553 -62.444)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal5List);
export default __webpack_public_path__ + "static/media/External 5_List.f45adb0a87f4247f77eb04a62da9aed8.svg";
export { ForwardRef as ReactComponent };